import Form1 from 'forms/clientsrequest/clientView'
import PropTypes from 'prop-types'

export default function Block({ title, className, users, values }) {
  return (
    <div
      className={`${className && className} 
      rounded border-2 shadow-md border-gray-300`}
    >
      <div className="flex items-center justify-between w-full px-2 py-2 text-sm uppercase bg-gray-300 print:py-1 font-ms-bold">
        <span>{title}</span>
      </div>

      <Form1 users={users} values={values} />
    </div>
  )
}

Block.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  users: PropTypes.array,
  values: PropTypes.object
}
